import { Link, useNavigate } from 'react-router-dom';
import { SYSTEM_PATH } from '../../../core/configs/constants';

import './Footer.scss';
import { observer } from 'mobx-react';
import { useStore } from '../../../core/utils/hook';
import classNames from 'classnames';

const FooterTopPage = observer(() => {
    // hook
    const navigate = useNavigate();

    // store
    const {
        authStore: { token },
        settingTopPageStore: { isPreview }
    } = useStore();

    const menuItemLinkTopPages = [
        {
            id: '#id-about-elephamt',
            label: 'エレファントとは',
            offset: 0
        },
        {
            id: '#id-section-services',
            label: '・初めての方へ',
            offset: 100
        },
        {
            id: '#id-section-introduction',
            label: '・学びやすい理由',
            offset: 100
        },
        {
            id: '#id-users-voice',
            label: '・利用者の声',
            offset: 100
        }
    ];

    const clearEventLink = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <footer id='Footer' className='footer-top-page'>
            <div className='container'>
                <div className='top-footer'>
                    <div className='row align-items-start'>
                        <div className='col-md-3 col-sm-3 col-4'>
                            <a className='logo-footer'>
                                <img src='/images/logo-small-1.png' alt='' />
                            </a>
                        </div>
                        <div className='col-md-9 col-sm-9 col-8'>
                            <div className='item-footer row'>
                                {isPreview ? (
                                    <>
                                        <div className="col-md-4 col-sm-6 col-12">
                                            <ul>
                                                {menuItemLinkTopPages?.map(item => {
                                                    return (
                                                        <li key={item?.id}>
                                                            <a
                                                                href={undefined}
                                                                className='item-menu-header'
                                                                onClick={clearEventLink}
                                                            >{item?.label}</a>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                        <div className='col-md-4 col-sm-6 col-12'>
                                            <ul>
                                                <li className='li-title'>
                                                    <Link to={undefined} onClick={clearEventLink}>講座一覧</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>よくある質問</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>お問合せ</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>新規受講の方はこちら</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>法人契約のお問合わせ方はこちら</Link>
                                                </li>
                                                <li>
                                                    <a href={undefined} target='_blank' onClick={clearEventLink}>利用マニュアル</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className='col-md-4 col-sm-6 col-12'>
                                            <ul>
                                                <li className='li-title'>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>特定商取引法</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>個人情報保護方針</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>利用規約</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>運営内容</Link>
                                                </li>
                                                <li>
                                                    <Link to={undefined} target='_blank' onClick={clearEventLink}>推奨環境</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {!token && (
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <ul>
                                                    {menuItemLinkTopPages?.map(item => {
                                                        const offSet = item?.offset;
                                                        return (
                                                            <li key={item?.id}>
                                                                <a
                                                                    href={`/${item?.id}`}
                                                                    className='item-menu-header'
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        navigate('/', { state: { scrollTo: item.id, offset: offSet } });
                                                                    }}
                                                                >{item?.label}</a>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        )}
                                        <div className={classNames(
                                            !token ? 'col-md-4 col-sm-6 col-12' : 'col-md-6 col-sm-6 col-12'
                                        )}>
                                            <ul>
                                                <li className='li-title'>
                                                    <Link to={SYSTEM_PATH.THEMES}>講座一覧</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.FAQ_SCREEN} target='_blank'>よくある質問</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.SEND_INQUIRY} target='_blank'>お問合せ</Link>
                                                </li>
                                                {!token && (
                                                    <li>
                                                        <Link to={SYSTEM_PATH.REGISTRATION_FIRST_STEP} target='_blank'>新規受講の方はこちら</Link>
                                                    </li>
                                                )}
                                                <li>
                                                    <Link to={`${SYSTEM_PATH.SEND_INQUIRY}?category=7`} target='_blank'>法人契約のお問合わせ方はこちら</Link>
                                                </li>
                                                <li>
                                                    <a href={`${window.location.origin}/files/UserManual.pdf`} target='_blank'>利用マニュアル</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className={classNames(
                                            !token ? 'col-md-4 col-sm-6 col-12' : 'col-md-6 col-sm-6 col-12'
                                        )}>
                                            <ul>
                                                <li className='li-title'>
                                                    <Link to={SYSTEM_PATH.SPECIFIED_COMMERCIAL_TRANSACTION_LAW_DISPLAY} target='_blank'>特定商取引法</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.PRIVACY_POLICY} target='_blank'>個人情報保護方針</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.TERM_OF_SERVICE} target='_blank'>利用規約</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.ABOUT_US} target='_blank'>運営内容</Link>
                                                </li>
                                                <li>
                                                    <Link to={SYSTEM_PATH.RECOMMENDED_ENVIRONMENT} target='_blank'>推奨環境</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div >
                <div className='copyright'>
                    <p>
                        Copyright © 2022 一般社団法人医学薬学ナレッジ
                        <br className='d-sm-none d-block' />
                        All rights reserved
                    </p>
                </div>
            </div >
        </footer >
    )
})

export default FooterTopPage;
